import { NuxtAxiosInstance } from '@nuxtjs/axios';
import { mapToUserProfile } from './mapper';
import {
  getUserProfileParams,
  updateUserProfileParams,
  updateUserPasswordParams
} from './type';

/**
 * fetchCurrentUserProfile
 * ユーザープロフィールを取得
 *
 * @param $axios NuxtAxiosInstance
 * @returns Promise<UserProfile>
 */
export const fetchCurrentUserProfile = async (
  $axios: NuxtAxiosInstance,
  params: getUserProfileParams = {}
): Promise<any> => { // eslint-disable-line @typescript-eslint/no-explicit-any
  // FIXME: 型安全を妥協した上でリリースを優先しました。
  // https://github.com/attelu/attelu-toC/pull/525/files#r1017753657
  const queryPrams = {} as { [key: string]: string | number | boolean};

  // 登録完了メール送信フラグ
  if (params?.isAfterRegistration) {
    queryPrams.is_after_registration = params.isAfterRegistration;
  }

  const { data } = await $axios.get('/v1/user/me/profile', {
    params: queryPrams
  });
  return mapToUserProfile(data.profile);
};

export const updateCurrentUserProfile = (
  $axios: NuxtAxiosInstance,
  params: updateUserProfileParams
) => {
  const formData = new FormData();
  formData.append('last_name', params.lastName);
  formData.append('first_name', params.firstName);
  formData.append('locale', params.locale);
  if (params.agreedWithTerms !== undefined) {
    formData.append('agreed_with_terms', params.agreedWithTerms ? '1' : '0');
  }

  if (
    params.yearOfBirth !== null &&
    params.monthOfBirth !== null &&
    params.dayOfBirth !== null
  ) {
    formData.append(
      'birth_date',
      `${params.yearOfBirth}-${params.monthOfBirth}-${params.dayOfBirth}`
    );
  }

  if (params.mobilePhone !== null) {
    formData.append('mobile_phone', params.mobilePhone);
  }

  if (params.icon !== null) {
    formData.append('icon', params.icon);
  }
  if (params.cover !== null) {
    formData.append('cover', params.cover);
  }

  formData.append(
    'is_receivable_notifications',
    params.isReceivableNotifications ? '1' : '0'
  );

  return $axios.put('/v1/user/me/profile', formData);
};

export const deleteUser = ($axios: NuxtAxiosInstance) => {
  return $axios.delete('/v1/user/me/profile');
};

export const updateCurrentUserPassword = (
  $axios: NuxtAxiosInstance,
  params: updateUserPasswordParams
) => {
  const formData = new FormData();
  formData.append('password', params.password);
  formData.append('password_confirmation', params.passwordConfirmation);

  return $axios.put('/v1/user/me/password', formData);
};

export const updateCurrentUserProfileByTicketBoxAccessToken = (
  $axios: NuxtAxiosInstance,
  ticketBoxAccessToken: string
) => {
  return $axios.put(`/v1/user/me/profile/ticket_boxes/${ticketBoxAccessToken}`);
};
